 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","16":"component---src-pages-404-js","17":"component---src-pages-atoms-button-index-mdx","18":"component---src-pages-atoms-logo-index-mdx","19":"component---src-pages-atoms-title-index-mdx","20":"component---src-pages-components-accordion-mdx","21":"component---src-pages-components-anchor-links-mdx","22":"component---src-pages-components-art-direction-index-mdx","23":"component---src-pages-components-article-card-mdx","24":"component---src-pages-components-aside-mdx","25":"component---src-pages-components-caption-mdx","26":"component---src-pages-components-code-blocks-mdx","27":"component---src-pages-components-do-dont-example-mdx","28":"component---src-pages-components-do-dont-row-mdx","29":"component---src-pages-components-feature-card-mdx","30":"component---src-pages-components-feedback-dialog-mdx","31":"component---src-pages-components-gif-player-mdx","32":"component---src-pages-components-grid-mdx","33":"component---src-pages-components-image-card-mdx","34":"component---src-pages-components-image-gallery-mdx","35":"component---src-pages-components-inline-notification-mdx","36":"component---src-pages-components-markdown-mdx","37":"component---src-pages-components-medium-posts-mdx","38":"component---src-pages-components-mini-card-mdx","39":"component---src-pages-components-page-description-mdx","40":"component---src-pages-components-resource-card-mdx","41":"component---src-pages-components-tabs-mdx","42":"component---src-pages-components-title-mdx","43":"component---src-pages-components-video-index-mdx","44":"component---src-pages-contributing-bugs-and-request-mdx","45":"component---src-pages-contributing-documentation-mdx","46":"component---src-pages-contributing-pattern-mdx","47":"component---src-pages-contributions-mdx","48":"component---src-pages-cranach-cranach-design-team-mdx","49":"component---src-pages-cranach-how-cranach-design-works-mdx","50":"component---src-pages-cranach-what-is-cranach-design-mdx","51":"component---src-pages-demo-index-mdx","52":"component---src-pages-design-design-kits-mdx","53":"component---src-pages-design-design-tutorials-mdx","54":"component---src-pages-design-get-started-mdx","55":"component---src-pages-design-other-ressources-mdx","56":"component---src-pages-design-overview-mdx","57":"component---src-pages-developing-developer-ressources-index-mdx","58":"component---src-pages-developing-get-started-index-mdx","59":"component---src-pages-developing-overview-index-mdx","60":"component---src-pages-developing-react-tutorial-index-mdx","61":"component---src-pages-gallery-index-mdx","62":"component---src-pages-getting-started-index-mdx","63":"component---src-pages-guidelines-color-index-mdx","64":"component---src-pages-guidelines-spacing-index-mdx","65":"component---src-pages-guidelines-typographie-index-mdx","66":"component---src-pages-guides-configuration-mdx","67":"component---src-pages-guides-hosting-mdx","68":"component---src-pages-guides-mdx-mdx","69":"component---src-pages-guides-navigation-sidebar-mdx","70":"component---src-pages-guides-navigation-tabs-mdx","71":"component---src-pages-guides-npm-scripts-mdx","72":"component---src-pages-guides-shadowing-mdx","73":"component---src-pages-guides-styling-mdx","74":"component---src-pages-help-contact-mdx","75":"component---src-pages-help-faq-mdx","76":"component---src-pages-index-mdx","77":"component---src-pages-molecules-artefact-card-index-mdx","78":"component---src-pages-molecules-definition-list-index-mdx","79":"component---src-pages-news-changelog-and-roadmap-mdx","80":"component---src-pages-news-meetups-mdx","81":"component---src-pages-news-news-and-article-mdx","82":"component---src-pages-news-work-in-progress-mdx","83":"component---src-pages-organism-artefact-details-index-mdx","84":"component---src-pages-organism-artefact-intro-index-mdx","85":"component---src-pages-pattern-overview-overview-mdx","86":"component---src-pages-test-spacing-audit-mdx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","16":"9cf8711bc464aaca1763","17":"89b50473262a8ec41b66","18":"37336a090f8ddc0b3275","19":"a5de3ae34c9ed80ec93a","20":"958124fed8a4f624f72f","21":"ba97bdd66ae571acbb07","22":"4c407ed64584b7b87a8e","23":"1bb855245970ad4c75ec","24":"b186586f2f191e85932d","25":"959a1cc0d0064310d340","26":"8b4cc0771191840dad05","27":"2f1ccd4fe0bd01a8c51c","28":"55eae49d3f879934f7e3","29":"34949a888fa86bb98b55","30":"1592ceb71602ce6ab042","31":"d53670d9ccd3a0dcd670","32":"9e46785d42819d32832e","33":"b90f24d46f28f24a823d","34":"304ece940b295a5634e3","35":"cab171138ab7e0d9d750","36":"8bbce04941e85541f435","37":"76e79c54a335d2f4d3af","38":"62cb930ae6b5f3dee6eb","39":"6ddc4278cf8a3598f218","40":"fbcc8307572409d74cd2","41":"f93aa76ab8601739709b","42":"c33da5841ccbd30a13bd","43":"674e69a5cbb8ac1ab423","44":"26b79e85dd13074bfbf4","45":"13ed6aff2a391f30f3cd","46":"6a2c46abcbc27b813248","47":"f3ae8cd4c262e068200e","48":"0ccdefab5d68beac2692","49":"ffdee54c4a0072c15a8b","50":"d06136f72d019255a7d1","51":"738fbee42f2881b309f2","52":"31284ece55ea43e3c0de","53":"93042dea887e59c015f4","54":"5f970224ccf36dda97cc","55":"89652f5f7f14c0bbad3e","56":"a4999a769bbc70a0c58a","57":"aaf7639c5fdbb916d05b","58":"1175b55e7a741da8257a","59":"54cbb62cd515909d8d03","60":"82106891c0fd12a08838","61":"ddbe6257c5134ff504f2","62":"e57de1ad0fe0de5b5901","63":"62d4c5f668f503027179","64":"1c48d018734cefdf88e1","65":"0ea36526565471dce043","66":"746501795c819dfdf2fb","67":"6758427343376e70c122","68":"19034af08e01362495f9","69":"2810d82c498c44a64c23","70":"d71c03f13aa799a20783","71":"863f122b3356c4f15c0d","72":"9565d3837466752e78f9","73":"76e8b78243394344fdef","74":"7c335407519d0655d031","75":"90a30c48cc4b238649fe","76":"4ecef556ef011272c81b","77":"2642e4f8797b99e531af","78":"244b72eada2eb9a02ca7","79":"7790f286b69e7e2cfb83","80":"4cdb9120481417917558","81":"40b604ecdb18e67fcec6","82":"ab019fceb08383dbe2ba","83":"173ead04155b324fd29f","84":"e4918454588b6d73990f","85":"80d69cc023284f04f2c6","86":"48bb919d5b27e68d098d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","16":"component---src-pages-404-js","17":"component---src-pages-atoms-button-index-mdx","18":"component---src-pages-atoms-logo-index-mdx","19":"component---src-pages-atoms-title-index-mdx","20":"component---src-pages-components-accordion-mdx","21":"component---src-pages-components-anchor-links-mdx","22":"component---src-pages-components-art-direction-index-mdx","23":"component---src-pages-components-article-card-mdx","24":"component---src-pages-components-aside-mdx","25":"component---src-pages-components-caption-mdx","26":"component---src-pages-components-code-blocks-mdx","27":"component---src-pages-components-do-dont-example-mdx","28":"component---src-pages-components-do-dont-row-mdx","29":"component---src-pages-components-feature-card-mdx","30":"component---src-pages-components-feedback-dialog-mdx","31":"component---src-pages-components-gif-player-mdx","32":"component---src-pages-components-grid-mdx","33":"component---src-pages-components-image-card-mdx","34":"component---src-pages-components-image-gallery-mdx","35":"component---src-pages-components-inline-notification-mdx","36":"component---src-pages-components-markdown-mdx","37":"component---src-pages-components-medium-posts-mdx","38":"component---src-pages-components-mini-card-mdx","39":"component---src-pages-components-page-description-mdx","40":"component---src-pages-components-resource-card-mdx","41":"component---src-pages-components-tabs-mdx","42":"component---src-pages-components-title-mdx","43":"component---src-pages-components-video-index-mdx","44":"component---src-pages-contributing-bugs-and-request-mdx","45":"component---src-pages-contributing-documentation-mdx","46":"component---src-pages-contributing-pattern-mdx","47":"component---src-pages-contributions-mdx","48":"component---src-pages-cranach-cranach-design-team-mdx","49":"component---src-pages-cranach-how-cranach-design-works-mdx","50":"component---src-pages-cranach-what-is-cranach-design-mdx","51":"component---src-pages-demo-index-mdx","52":"component---src-pages-design-design-kits-mdx","53":"component---src-pages-design-design-tutorials-mdx","54":"component---src-pages-design-get-started-mdx","55":"component---src-pages-design-other-ressources-mdx","56":"component---src-pages-design-overview-mdx","57":"component---src-pages-developing-developer-ressources-index-mdx","58":"component---src-pages-developing-get-started-index-mdx","59":"component---src-pages-developing-overview-index-mdx","60":"component---src-pages-developing-react-tutorial-index-mdx","61":"component---src-pages-gallery-index-mdx","62":"component---src-pages-getting-started-index-mdx","63":"component---src-pages-guidelines-color-index-mdx","64":"component---src-pages-guidelines-spacing-index-mdx","65":"component---src-pages-guidelines-typographie-index-mdx","66":"component---src-pages-guides-configuration-mdx","67":"component---src-pages-guides-hosting-mdx","68":"component---src-pages-guides-mdx-mdx","69":"component---src-pages-guides-navigation-sidebar-mdx","70":"component---src-pages-guides-navigation-tabs-mdx","71":"component---src-pages-guides-npm-scripts-mdx","72":"component---src-pages-guides-shadowing-mdx","73":"component---src-pages-guides-styling-mdx","74":"component---src-pages-help-contact-mdx","75":"component---src-pages-help-faq-mdx","76":"component---src-pages-index-mdx","77":"component---src-pages-molecules-artefact-card-index-mdx","78":"component---src-pages-molecules-definition-list-index-mdx","79":"component---src-pages-news-changelog-and-roadmap-mdx","80":"component---src-pages-news-meetups-mdx","81":"component---src-pages-news-news-and-article-mdx","82":"component---src-pages-news-work-in-progress-mdx","83":"component---src-pages-organism-artefact-details-index-mdx","84":"component---src-pages-organism-artefact-intro-index-mdx","85":"component---src-pages-pattern-overview-overview-mdx","86":"component---src-pages-test-spacing-audit-mdx"}[chunkId]||chunkId) + "." + {"0":"c6a29a4dc720f024bc0a","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
